import React from 'react';
import {useParams} from 'react-router';
import {Box, Container, Skeleton, Stack, styled, Typography, useMediaQuery, useTheme} from '@mui/material';
import withMainContainer from '../../components/WithMainContainer.js';
import {withPermGuard} from '../../components/PermGuard.js';
import {usePost} from './blog_util.js';
import {useQueryParam} from '../../util/react_hooks.js';

const IMAGE_SIZE_BREAKPOINTS = {sm: 200, md: 400, lg: 600};

const BlogPostBodyContainer = styled(Box, {shouldForwardProp: p=>!p.startsWith('$')})`
    width: 100%;
    figure {
        margin: auto;
        max-width: ${p=>IMAGE_SIZE_BREAKPOINTS[p.$size]}px;
    }
    figure img {
        max-width: ${p=>IMAGE_SIZE_BREAKPOINTS[p.$size]}px;
    }
`;

const BlogPostSkeleton = ()=><>
  <Skeleton variant="rounded" width="50%" height={100}/>
</>;

const BlogPostComp = props=>{
    let {post} = props;
    let theme = useTheme();
    let md = useMediaQuery(theme.breakpoints.down('md'));
    let sm = useMediaQuery(theme.breakpoints.down('sm'));
    return <>
      <Typography variant="h3">
        {post.data.title}
      </Typography>
      <BlogPostBodyContainer dangerouslySetInnerHTML={{__html: post.data.body}}
        $size={sm ? 'sm' : md ? 'md' : 'lg'}/>
    </>;
};

const BlogPost = ()=>{
    let {slug} = useParams();
    let [preview] = useQueryParam('preview');
    let [post, loading] = usePost(slug, !!preview);
    console.log(post);
    return <Container maxWidth="lg">
      <Stack direction="column" gap={2} justifyContent="center" alignItems="center">
        {loading ? <BlogPostSkeleton/> : post ? <BlogPostComp post={post}/>: null}
      </Stack>
    </Container>;
};

export default withMainContainer(withPermGuard(BlogPost, 'admin'), {footerMargin: 4});
